
const _ = require('lodash');

const defaultState = {
    inboxInstructionsActive: [],
    loadingActive: false,
    errorsActive:{} 
}
  
  export default (state=defaultState, action={}) => {
    switch (action.type) {

      //instrucoes ativas 
      case 'FETCH_INBOX_INSTRUCTIONS_ACTIVE_FULFILLED': {
        return {
          ...state,
          inboxInstructionsActive: action.payload.data,
          loadingActive: false,
          errorsActive: {}
        }
      }
  
      case 'FETCH_INBOX_INSTRUCTIONS_ACTIVE_PENDING': {
        return {
          ...state,
          loadingActive: true,
          errorsActive: {}
        }
      }
  
      case 'FETCH_INBOX_INSTRUCTIONS_ACTIVE_REJECTED': {
        return {
          ...state,
          loadingActive: false,
          errorsActive: { global: action.payload.message }
        }
      }      


      case 'VALIDATE_INSTRUCTION_FULFILLED': {
        const newItem = action.newItem;
        //Lista de ativas
        // Step 1. Remove previous validated for the same generation unit
        let finalList = [];
        state.inboxInstructionsActive.forEach(element => {
          if ( !(element.COD_SIME === newItem.COD_SIME && element.COUNTRY_CODE === newItem.COUNTRY_CODE)) {
            finalList.push(element);
          }
        });
        // Step 2. Add the "validated" instruction and order the list
        finalList.push(newItem);
        let orderedInstructions = _.orderBy(finalList, ['ORDER_NS'], ['asc']);        

        return {
            ...state,
            inboxInstructionsActive: orderedInstructions
        }
      }  
      
      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/production-hidro-active-reducer.js